"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../DomainObject");
/**
 * Description of form field.
 *
 * @author Radek Beran
 */


var FormField =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(FormField, _DomainObject_1$Domai);

  /**
   * Constructs form field definition.
   * @param name name of field
   * @param codebook values to offer for choice (null if not applicable)
   */
  function FormField(name, codebook) {
    var _this;

    _classCallCheck(this, FormField);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FormField).call(this));
    _this.name = name;
    _this.codebook = codebook; // other configuration can be added: readonly, required etc.
    // if there is need for different configuration for different users

    return _this;
  }

  return FormField;
}(DomainObject_1.DomainObject);

exports.FormField = FormField;